import { SplitText } from '@/utilities/SplitText';

export default {
    init() {
        const element = document.querySelectorAll('[data-lines-up]');

        element.forEach(linesUp => {
            const split = new SplitText(linesUp, { type: 'lines' });
            const delay = linesUp.getAttribute('data-lines-up');
            const toggleActions = linesUp.getAttribute('data-toggle-actions');

            gsap.from(split.lines, {
                y: '200%',
                opacity: 0,
                duration: 1,
                stagger: 0.08,
                delay: delay,
                ease: 'circ.out',
                scrollTrigger: {
                    trigger: element,
                    once: false,
                    toggleActions: toggleActions ? toggleActions : 'play none play none'
                }
            });
        });
    }
};
